export default __webpack_public_path__ + "static/media/Hair_12_M_C5.2b082d3f.svg";